import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button type="button" data-testid="back-to-top-button" aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="nl-fade-up fixed bottom-6 right-4 sm:right-6 z-50 h-11 w-11 rounded-full
        bg-[#7C3AED] hover:bg-[#6D28D9] text-white
        shadow-xl shadow-black/50 flex items-center justify-center transition-colors">
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};
